import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../Global/EmptyData";
import OrderColumn from "../../Global/OrderColumn";
import useOfficeDelivery from "./useOfficeDelivery";
import AddOfficeDelivery from "./AddOfficeDelivery";

const OfficeDelivery = () => {
  const {
    isLoading,
    isFetching,
    officeDeliveryList,
    showEditModal,
    officeDeliveryState,
    paginationOptions,
    handleEditColumnsClick,
    updateOfficeDeliveryFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useOfficeDelivery();

  return (
    <div>
      <HeadingGroup
        title={"Office Delivery"}
        className={`pro-mb-4`}
        buttonTitle={officeDeliveryList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={officeDeliveryState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: officeDeliveryState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {officeDeliveryList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={officeDeliveryList?.data?.result || []}
            uniqueID={"_id"}
            fields={officeDeliveryList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={officeDeliveryState?.clearSelection}
            loading={isFetching}
            perpage={officeDeliveryState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={officeDeliveryList?.delete_permission}
            editable={officeDeliveryList?.edit_permission}
            showCheckBox={
              officeDeliveryList?.delete_permission ||
              officeDeliveryList?.edit_permission
            }
          />
        )}

        {officeDeliveryList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={officeDeliveryState?.currentPage}
            totalPageCount={Math.ceil(
              officeDeliveryList?.data?.total_count / officeDeliveryState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === officeDeliveryState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={officeDeliveryState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected office delivery ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={officeDeliveryList?.fields || []}
              moduleId={officeDeliveryList?.module_id}
              updateData={updateOfficeDeliveryFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={officeDeliveryState?.showCreateModal}
          handleClose={handleCreateClick}
          title={officeDeliveryState?.isEdit ? "Update Office Delivery" : "Add Office Delivery"}
          backdrop={"static"}
        >
          <AddOfficeDelivery
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
          />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default OfficeDelivery;
